import axiosRetry, { isRetryableError } from 'axios-retry';
import EnvConfig from '../../../config/client';

export const shouldRetry = (error) => isRetryableError(error);

// This function is a based on axios-retry's exponentialDelay function.
// Here we used a longer delay factor 500ms, which was just 100ms.
export const exponentialDelay = (...params) => {
  const retryNumber =
    params.length > 0 && params[0] !== undefined ? params[0] : 0;
  const delay = 2 ** retryNumber * 500;
  const randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay
  return delay + randomSum;
};

const setupAxiosRetry = (axios, options = {}) => {
  const retryDefaults = EnvConfig.axiosRetry;
  const retryOptions = {
    ...retryDefaults,
    retryCondition: shouldRetry,
    retryDelay: exponentialDelay,
    ...options,
  };
  axiosRetry(axios, retryOptions);
};

export default setupAxiosRetry;
